import { createContext, useContext } from 'react';
const FeatureFlagContext = createContext({
    isWealthManagement: false,
    isOrderDebitCardEnabled: false,
    isManageDebitCardEnabled: false,
    isMortgageDeeplinkingEnabled: false,
    isReplaceDebitCardEnabled: false,
    isMortgageEnabled: false,
    isPrivacyPreferencesEnabled: false,
    isAutoEnabled: false,
    isAutoAlertsEnabled: false,
    isDebtPlanEnabled: false,
    isCreditCardEnabled: false,
    isGuestEnabled: false,
    isPersonalAdviceEnabled: false,
    isDirectDepositEnabled: false,
    isInvestEnabled: false,
    isCreditScoreEnabled: false,
});
export const FeatureFlagProvider = FeatureFlagContext.Provider;
export const useFeatureFlags = () => useContext(FeatureFlagContext);
//# sourceMappingURL=FeatureFlagContext.js.map